"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireWildcard(require("axios"));

var _token = _interopRequireDefault(require("./token.js"));

var _log = _interopRequireDefault(require("./log.js"));

var _axiosRetry = _interopRequireDefault(require("axios-retry"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var axios = _axios.create();

axios.interceptors.request.use(function (config) {
  return new Promise(function (resolve, reject) {
    _token["default"].get().then(function (token) {
      // we dont ALWAYS want the bearer token added to the headers
      if (!config.stripAuthorization) {
        config.headers['Authorization'] = "Bearer ".concat(token);
      }

      resolve(config);
    })["catch"](function (error) {
      _log["default"].warn('Unable to generate bearer token. Sending without Authorization header.', error);

      resolve(config);
    });
  });
}, function (error) {
  _log["default"].error('request error', error);

  return Promise.reject(error);
}); // https://github.com/softonic/axios-retry/issues/87

var retryDelay = function retryDelay() {
  var retryNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var seconds = Math.pow(2, retryNumber) * 1000;
  var randomMs = 1000 * Math.random();
  return seconds + randomMs;
};

var retryCondition = function retryCondition(err) {
  // window.navigator.onLine = if this is false then you're reliably offline, but it can give false positives.
  // isRetryableError = retry on Network Error & 5xx responses.
  return (typeof window === 'undefined' || window.navigator.onLine) && _axiosRetry["default"].isRetryableError(err);
};

(0, _axiosRetry["default"])(axios, {
  retries: 2,
  retryDelay: retryDelay,
  retryCondition: retryCondition
});
var _default = axios;
exports["default"] = _default;